module.exports = __webpack_public_path__ + "img/inbox (1).c942d9a5.png";